import { useTranslation } from "react-i18next";

import { Section, SectionHeader, SectionTitle } from "@/blocks/Section";

import { TalkRatioList } from "./TalkRatioList";

import { useCall } from "@/hooks/useCall/useCall";

export function SectionTalkRatio() {
  const { t } = useTranslation();
  const { call } = useCall();

  if (!call) {
    return null;
  }

  return (
    <Section data-test="talk-ratio-section">
      <SectionHeader>
        <SectionTitle>{t("call_context.talk_ratio")}</SectionTitle>
      </SectionHeader>
      <TalkRatioList speakers={call.speakers} talkRatio={call.talkRatio} />
    </Section>
  );
}
